// These scenes own their canvas textures. Release the pixel storage as well
// as GPU resources; detached canvases can outlive a round on mobile Safari.
export const disposeCanvasTexture = (texture) => {
  texture.dispose();
  const canvas = texture.source?.data || texture.image;
  if (
    typeof HTMLCanvasElement !== 'undefined' &&
    canvas instanceof HTMLCanvasElement
  ) {
    canvas.width = 1;
    canvas.height = 1;
  }
};

export const disposeSceneResources = (scene) => {
  const geometries = new Set();
  const materials = new Set();
  const textures = new Set();
  const shadows = new Set();
  scene.traverse((object) => {
    if (object.geometry) geometries.add(object.geometry);
    if (object.shadow) shadows.add(object.shadow);
    for (const material of Array.isArray(object.material)
      ? object.material
      : [object.material]) {
      if (!material) continue;
      materials.add(material);
      for (const value of Object.values(material))
        if (value?.isTexture) textures.add(value);
      for (const uniform of Object.values(material.uniforms || {}))
        if (uniform.value?.isTexture) textures.add(uniform.value);
    }
  });
  textures.forEach(disposeCanvasTexture);
  shadows.forEach((shadow) => shadow.dispose());
  geometries.forEach((geometry) => geometry.dispose());
  materials.forEach((material) => material.dispose());
};
